import algoliasearch from "algoliasearch/lite"

const searchClient = algoliasearch(
	process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_APP_ID,
	process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_SEARCH_KEY,
)

export default searchClient
